module.exports = {
  environmentName: process.env.NEXT_PUBLIC_ENVIRONMENT_NAME,
};
